export const USER_UUID_COOKIE = "userUuid"
export const USER_UUID_COOKIE_EXPIRATION_DAYS = 1
export const TRANSLATIONS_COOKIE = "translationsLoaded"
export const TRANSLATIONS_COOKIE_EXPIRATION_DAYS = 1
export const TRANSLATIONS_EXPIRATION_DATE_COOKIE = "translationsExpirationDate"

export const cookiesService = {
  create(name, expireDate, value = "", path = "/") {
    document.cookie = `${name}=${value}; expires=${expireDate}; path=${path}`
  },

  get(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
  },

  delete(name) {
    document.cookie = `${name}=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/;`
  },

  checkIfExist(name) {
    return typeof this.get(name) !== "undefined"
  },

  // unused function
  // createUserUuidCookie() {
  //   const token = localStorageService.getAccessToken()
  //   if (token) {
  //     const userLogged = tokenService.parseJwt(token)
  //     const userUuid = userLogged["@id"].split("/").pop()
  //
  //     let today = new Date()
  //     let expireDate = new Date()
  //     expireDate.setDate(today.getDate() + USER_UUID_COOKIE_EXPIRATION_DAYS)
  //
  //     this.create(USER_UUID, expireDate, userUuid)
  //   }
  // },

  createTranslationsCookie() {
    let today = new Date()
    let tomorrow = new Date()

    tomorrow.setDate(today.getDate() + TRANSLATIONS_COOKIE_EXPIRATION_DAYS)

    this.create(TRANSLATIONS_COOKIE, tomorrow, tomorrow)
    this.create(TRANSLATIONS_EXPIRATION_DATE_COOKIE, tomorrow, tomorrow)
  },

  getTranslationsCookie() {
    return this.get(TRANSLATIONS_COOKIE)
  }
}
